import { formatMoney } from './utils-format-money.js';

class TierPricing extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.tiers = JSON.parse(this.dataset.tiers || '[]');
    this.currencyRate = Shopify.currency.rate || 1;

    this.updatePricesInDocument();

    this.unsubscribeQuantityChange = subscribe('quantity:change', ({ quantity }) => {
      this.handleQuantityChange(quantity);
    });
  }

  disconnectedCallback() {
    this.unsubscribeQuantityChange();
  }

  updatePricesInDocument() {
    const priceCells = this.querySelectorAll('td[data-price-cents]');
    priceCells.forEach((cell) => {
      const priceCents = parseInt(cell.dataset.priceCents, 10);
      cell.textContent = formatMoney(priceCents * this.currencyRate);
    });
  }

  handleQuantityChange(quantity) {
    const parsedQuantity = parseInt(quantity, 10);
    const tierPrice = this.getTierPrice(parsedQuantity);

    publish('tier:price:change', {
      productId: this.productId,
      quantity: parsedQuantity,
      tierPrice,
      unitPrice: tierPrice ? tierPrice.price : null,
      hasTier: !!tierPrice,
    });

    this.updateTierDisplay(parsedQuantity);
  }

  getTierPrice(quantity) {
    if (!this.tiers || this.tiers.length === 0) return null;

    let applicableTier = null;

    for (const tier of this.tiers) {
      const tierQuantity = parseInt(tier[0], 10);
      const tierPriceCents = parseInt(tier[1], 10);

      if (quantity >= tierQuantity) {
        applicableTier = {
          quantity: tierQuantity,
          price: tierPriceCents * this.currencyRate,
        };
      } else {
        break;
      }
    }

    return applicableTier;
  }

  updateTierDisplay(quantity) {
    const rows = this.querySelectorAll('tbody tr');
    const applicableTier = this.getTierPrice(quantity);

    rows.forEach((row) => {
      const qtyCell = row.querySelector('td:first-child');
      const tierQty = parseInt(qtyCell.textContent.trim(), 10);

      row.classList.remove('font-bold');

      if (applicableTier && tierQty === applicableTier.quantity) {
        row.classList.add('font-bold');
      }
    });
  }
}

customElements.define('tier-pricing', TierPricing);
